import { useLang } from '../i18n'
import { deployProfile } from '../lib/backend'
import { isDesktopApp } from '../lib/desktop'
import { navigate, releasesPath } from '../lib/router'
import { APP_VERSION } from '../lib/version'

export function Footer() {
  const { t } = useLang()
  const profile = deployProfile()
  // Absent in a plain browser (no window.niobeDesktop at all); undefined for a desktop build old
  // enough to predate this field. Either way, no version to show is no line to show.
  const desktopVersion = isDesktopApp() ? window.niobeDesktop?.appVersion : undefined
  return (
    <footer className="footer">
      {desktopVersion && (
        <>
          <span className="v">Desktop v{desktopVersion}</span>
          <span className="sep">·</span>
        </>
      )}
      {/* Bottom-left: the deployed version, bumped once per deploy by niobe-devops. It replaced a
          static "MVP" chip, which said nothing about which build you were actually looking at. */}
      <button className="v vlink" onClick={() => navigate(releasesPath)} title={t('releases_title')}>
        Niobe v{APP_VERSION}
      </button>
      <span className="sep">·</span>
      <span className={`env ${profile}`}><span className="d" /> {t(`f_profile_${profile}`)}</span>
      <span className="gap" />
      <button className="flink" onClick={() => navigate(releasesPath)}>{t('releases_link')}</button>
    </footer>
  )
}
